import React, { forwardRef } from 'react';
import styles from './DropDownResults.module.css';
import { SelectedItem, MultiSelectDropDownOption } from './types';
import { SELECTION_TYPES, SelectionType } from './constants';
import OptionText from './OptionText';
import ActionButtons from './ActionButtons';

interface DropDownOptionProps {
  option: MultiSelectDropDownOption;
  status?: SelectedItem;
  isFocused: boolean;
  onItemSelect: (value: string, group?: string, type?: SelectionType, label?: string) => void;
  group?: string;
  optionIndex: number;
}

const DropDownOption = forwardRef<HTMLDivElement, DropDownOptionProps>(
  ({ option, status, isFocused, onItemSelect, group, optionIndex }, ref) => (
    <div
      ref={ref}
      className={`${styles.option} ${status ? styles[status.type] : ''} ${isFocused ? styles.focused : ''}`}
      onClick={() => onItemSelect(option.id, group, SELECTION_TYPES.INCLUDE, option.value)}
      role="option"
      id={`option-${optionIndex}`}
    >
      <OptionText option={option} />
      <ActionButtons option={option} group={group} status={status} onItemSelect={onItemSelect} />
    </div>
  ),
);

DropDownOption.displayName = 'DropDownOption';

export default DropDownOption;
